import { ElementRef, EventEmitter } from '@angular/core';
import { InfluencerNote } from '../../../../models/influencer-note';
import { AuthService } from '../../../core/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { CommonConstant } from '../../../app.constants';
var InlineEditNoteComponent = /** @class */ (function () {
    function InlineEditNoteComponent(authService, translate) {
        this.authService = authService;
        this.translate = translate;
        this.isSampleNote = false;
        this.addNoteSucessCallback = new EventEmitter();
        this.deleteNoteSucessCallback = new EventEmitter();
        this.blurCallback = new EventEmitter();
        this.deletingNoteCallback = new EventEmitter();
        this.readonly = true;
        this.noteHeight = CommonConstant.DEFAULT_NOTE_HEIGHT;
        this.canEditable = false;
    }
    InlineEditNoteComponent.prototype.ngOnInit = function () {
        this.readonly = this.isSampleNote || (this.note && this.note.id > 0);
    };
    InlineEditNoteComponent.prototype.onKeyDown = function (e) {
        if (e.keyCode === 13 && (e.metaKey || e.ctrlKey)) {
            this.createOrUpdateNote();
            e.preventDefault();
        }
    };
    InlineEditNoteComponent.prototype.onKeyUp = function (e) {
        var textArea = this.noteContainer.nativeElement.querySelector('.influencer-note');
        if (textArea) {
            textArea.style.height = CommonConstant.DEFAULT_NOTE_BOX_STYLE_HEIGHT;
            textArea.style.height = textArea.scrollHeight + 'px';
        }
    };
    InlineEditNoteComponent.prototype.createOrUpdateNote = function (isCreated) {
        if (isCreated === void 0) { isCreated = true; }
        var currentUser = this.authService.getUser();
        if (!currentUser) {
            this.authService.logout();
            return;
        }
        this.note.userId = Number(currentUser.data.id);
        this.addNoteSucessCallback.emit({
            note: this.note,
            isCreated: isCreated
        });
        this.readonly = true;
    };
    InlineEditNoteComponent.prototype.editNote = function () {
        var _this = this;
        if (!this.canEditNote) {
            return;
        }
        if (this.noteContainer) {
            var contentBox = this.noteContainer.nativeElement.querySelector('.content-inner');
            if (contentBox) {
                this.noteHeight = contentBox.scrollHeight;
            }
        }
        this.readonly = false;
        this.lastChangeContent = this.note.content;
        setTimeout(function () {
            _this.contextBox.nativeElement.focus();
        }, 200);
    };
    InlineEditNoteComponent.prototype.onBlur = function (evt) {
        if (document.contains(evt.target) && !this.readonly && this.note.content === '') {
            this.readonly = true;
            this.note.content = this.lastChangeContent;
            this.lastChangeContent = null;
            if (this.blurCallback) {
                this.blurCallback.emit();
            }
        }
        if (this.lastChangeContent && this.lastChangeContent !== this.note.content) {
            this.createOrUpdateNote(false);
        }
    };
    InlineEditNoteComponent.prototype.onMouseenter = function () {
        var currentUser = this.authService.getUser();
        if (!currentUser || !currentUser.data) {
            this.canEditable = false;
            return;
        }
        this.canEditable = this.note.userId === Number(currentUser.data.id);
    };
    InlineEditNoteComponent.prototype.onMouseleave = function () {
        this.canEditable = false;
    };
    InlineEditNoteComponent.prototype.deleteNote = function (noteId) {
        this.deletingNoteCallback.emit(noteId);
    };
    Object.defineProperty(InlineEditNoteComponent.prototype, "canEditNote", {
        get: function () {
            return this.readonly && this.canEditable;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InlineEditNoteComponent.prototype, "lastModificationDate", {
        get: function () {
            if (!this.note) {
                return null;
            }
            return this.note.modifiedAt ? this.note.modifiedAt : this.note.createdAt;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InlineEditNoteComponent.prototype, "userName", {
        get: function () {
            if (!this.note || (this.note && this.note.userId === 0)) {
                return '';
            }
            if (this.note.userId !== 0 && !this.note.userName) {
                return this.translate.instant('note.deleted_user');
            }
            return this.note.userName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InlineEditNoteComponent.prototype, "canSaveNote", {
        get: function () {
            return this.note && this.note.content && this.note.content.trim() !== '';
        },
        enumerable: true,
        configurable: true
    });
    return InlineEditNoteComponent;
}());
export { InlineEditNoteComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer/inline-edit-note/inline-edit-note.component.ts.pre-build-optimizer.js